<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right">Công ty<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @click="emitEvent" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên danh mục mối nguy<span class="required"></span></label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right">DANH SÁCH MỐI NGUY</label>
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên rủi ro<span class="required"></span></label>
          <InputText
            v-model="name_danger"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name_danger" />
        </div>
        <div class="mt-3">
          <Checkbox v-model="active_danger" :binary="true" /> Hiển thị mối nguy này
        </div>
        <div class="mt-3">
          <Button
            v-if="$store.getters.controllers?.list_category_danger && $store.getters.controllers?.list_category_danger.includes('edit')"
            @click="AddDanger()"
            type="button"
            icon="pi pi-plus"
            class="button-box-1 p-button-add ml-0"
          />
        </div>
        <div class="mt-3">
          <table id="tb_level">
            <tr>
              <th style="width: 50px;">STT</th>
              <th>Mối nguy</th>
              <th style="width: 110px;">Trạng thái</th>
              <th style="width:90px">Hiển thị</th>
              <th style="width: 90px;"></th>
            </tr>
            <tr v-for="(item, index) in danger" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.status_text}}</td>
              <td style="text-align: center;"><span v-html="item.active_text"></span></td>
              <td style="text-align: center;" >
                <Button v-if="item.status=='APPROVED' && $store.getters.controllers?.list_category_danger && $store.getters.controllers?.list_category_danger.includes('edit')"
                  @click="EditItem(index)"
                  icon="pi pi-pencil"
                  class="button-box p-button-edit"
                >
                </Button>
                <Button v-if="item.status=='WAITTING' && $store.getters.controllers?.list_category_danger && $store.getters.controllers?.list_category_danger.includes('edit')"
                  @click="ApprovedItem(index)"
                  icon="pi pi-pencil"
                  class="button-box"
                ><i style ="" class="material-icons">published_with_changes</i>
                </Button>
                <Button
                  v-if="$store.getters.controllers?.list_category_danger && $store.getters.controllers?.list_category_danger.includes('delete')"
                  @click="showDeleteData(index)"
                  icon="pi pi-trash"
                  class="button-box p-button-danger"
                />
          </td>
            </tr>
          </table>
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" /> Hiển thị danh mục này
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
    <Dialog
    style=""
    header="Cập nhật"
    :visible.sync="showEditDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div class="">
        <label class="txt-right">Tên rủi ro<span class="required"></span></label>
        <InputText
          v-model="item_edit.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
          maxlength="255"
        />
        <input class="input_tmp_validator" id="name_danger_edit" />
      </div>
      <div class="">
        <Checkbox v-model="item_edit.active" :binary="true" /> Hiển thị mối nguy này
      </div>
      
    <template
      #footer
    >
      <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showEditDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  <Dialog
    style=""
    header="Xóa"
    :visible.sync="showDelete"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
    Bạn có chắc muốn xoá mối nguy này không?
    <template #footer>
      <Button label="Xác nhận" @click="deleteItem()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showDelete = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  <Dialog
    header="Duyệt mối nguy"
    :visible.sync="showApprovedDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div style="max-width:500px">
        <span>Mối nguy này được tạo khi đánh giá. Sau khi duyệt, mối nguy này sẽ được hiển thị cho toàn bộ người dùng trong công ty. Bạn có chắc muốn duyệt không?</span>
      </div>
      <div class="">
        <label class="txt-right">Danh mục mối nguy<span class="required"></span></label>
        <Dropdown style="width: auto" v-model="selCategory" :options="listCategory" optionValue="id"  optionLabel="name"
          @change="getListDangerEvent($event)" />
        <input class="input_tmp_validator" id="name_danger_edit" />
      </div>
      <div class="">
        <label class="txt-right">Tên rủi ro<span class="required"></span></label>
        <InputText
          v-model="item_approved.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
          maxlength="255"
        />
        <input class="input_tmp_validator" id="name_danger_approved" />
      </div>
      <div class="" style="pandding-top:5px">
        <input type="radio" id="save_approved" v-model="radio_btn" value="1">
        <span> Lưu thay đổi & duyệt mối nguy</span><br>
        <input type="radio" id="save" v-model="radio_btn" value="2">
        <span> Chỉ lưu thay đổi</span><br>
        <input type="radio" id="javascript" v-model="radio_btn" value="3">
        <span> Thay thế bằng mối nguy đã có</span>
      </div>
      <div v-if="radio_btn==3" class="" style="padding-left: 15px;">
        <label class="txt-right">Chọn mối nguy có sẵn<span class="required"></span></label>
        <Dropdown style="width: auto" v-model="selDanger" :options="listDanger" optionValue="id"  optionLabel="name" placeholder="Chọn mối nguy có sẵn"/>
        <input class="input_tmp_validator" id="choose_danger_approved" />
      </div>
    <template
      #footer
    >
      <Button
        label="Hủy"
        @click="showApprovedDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
      <Button label="Xác nhận" @click="ApprovedData()" icon="pi pi-check" class="" />
    </template>
  </Dialog>
  </form>
  
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  components: {
    DropdownScrollable
  },
  data() {
    return {
      filters: {},
      name: "",
      code: "",
      name_danger: "",
      active_danger: true,
      point : null,
      danger : [],
      type_login : this.$store.getters.type ? this.$store.getters.type : null,
      danger_deleted : [],
      showEditDialog : false,
      showApprovedDialog : false,
      item_edit : {
        id: null,
        name: "",
        active: "",
        status : "",
        index : null,
        is_old : true,
      },
      item_approved : {},
      company : {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      active: true,
      listCategory : [],
      selCategory : null,
      selCategory_old : null,
      radio_btn : 1,
      listDanger : [],
      selDanger : null,
      showDelete : false,
      index_deleted : false,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
    };
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      setTimeout(() => {
        this.company = this.model.company;
        this.getListCategory()
      }, 100);
      this.name = this.model.name;
      this.code = this.model.code;
      this.selCategory_old = {
        id : this.model.id,
        name : this.model.name
      }
      // this.danger = this.model.danger;
      var tmp = this.model.danger;
      var count = tmp.length
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].is_old = true
        tmp[i].ordinal = count-1
        count--
        if(tmp[i].status == 'APPROVED'){
          tmp[i].status_text = 'Đã duyệt'
          if(tmp[i].active == true){
            tmp[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            tmp[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          tmp[i].status_text = 'Chưa duyệt'
          tmp[i].active_text =''
        }
      }
      this.sortDataV2(tmp)
      this.active = this.model.active;
    }
  },
  methods: {
    async getListDangerEvent(event) {
      console.log(event);
      await this.getListDanger()
    },
    getCompany(value) {
      this.company = value;
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
              this.company_obj.items.push(...res.data.data.company);
            } else{
              this.company_obj.items = res.data.data.company;
            }
            this.company_obj.total = res.data.data.total;
            this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    EditItem(index){
      const danger = this.danger[index];
      this.item_edit = {
        id : danger.id,
        name: danger.name,
        status: danger.status,
        active : danger.active,
        is_old : danger.is_old,
        index : index,
        ordinal : danger.ordinal,
      }
      this.showEditDialog = true
    },
    async validateDataApproved() {
      let name_danger_approved = document.getElementById("name_danger_approved");
      if (this.item_approved.name == undefined || this.item_approved.name == null || this.item_approved.name == "") {
        name_danger_approved.setCustomValidity("Tên rủi ro không được để trống!");
      } else if (this.item_approved.name.length > 255) {
        name_danger_approved.setCustomValidity("Tên rủi ro không được quá 255 ký tự!");
      } else {
        var checkExistName = this.danger.filter((f, i) => f.name.toLowerCase().trim() == this.item_approved.name.toLowerCase().trim() && i != this.item_approved.index);
        if (checkExistName.length > 0){
          name_danger_approved.setCustomValidity(`Tên rủi ro ${this.item_approved.name} đã tồn tại!`);
        } else {
          name_danger_approved.setCustomValidity("");
        }
      }
      if(this.radio_btn == 3){
        let choose_danger_approved = document.getElementById("choose_danger_approved");
        if(this.selDanger == undefined || this.selDanger == null){
          choose_danger_approved.setCustomValidity("Vui lòng chọn mối nguy thay thế!");
        }else{
          choose_danger_approved.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async ApprovedData(){
      this.$commonFuction.is_loading(true);
      if (await this.validateDataApproved()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var objects = {
        company_id : company_id,
        category_id : this.selCategory,
        danger_id : this.selDanger,
        id : this.item_approved.id,
        name : this.item_approved.name,
        radio_btn : this.radio_btn,
        category_id_old : this.model.id,
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      const headers = {
        "Authorization": "Bearer "+token,
      };   
      var that = this
      await ApiRepository.post("/_api/danger/change", objects, {headers}).then(async function (response) {
        if (response.status === 200) {
          await that.getDangerData();
          that.toastSuccess('Lưu dữ liệu thành công')
          that.showApprovedDialog = false
          that.$commonFuction.is_loading(false);
        } else {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: response.data.message,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        }
      }).catch((err) => {
        if(err.response && err.response.data && err.response.data.message == 'DANGER_EXSIT'){
          var text_err = 'Mối nguy đã tồn tại trong phiếu đánh giá'
          if(err.response.data.data){
            text_err += ' "'+err.response.data.data.name+'"'
          }
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: text_err,
            life: 5000
          });
        }else{
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
        }
        that.$commonFuction.is_loading(false);
      })
    },
    toastSuccess(text){
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Success', detail: text, life: 3000 })
    },
    async getDangerData(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listDanger = []
      var filters = {id : this.model.id}
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/category/danger", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
          var data = response.data.data;
          listDanger = data.list;
        })
      }
      var count = listDanger.length
      for (let i = 0; i < listDanger.length; i++) {
        listDanger[i].is_old = true
        listDanger[i].ordinal = count-1
        count--
        if(listDanger[i].status == 'APPROVED'){
          listDanger[i].status_text = 'Đã duyệt'
          if(listDanger[i].active == true){
            listDanger[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            listDanger[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          listDanger[i].status_text = 'Chưa duyệt'
          listDanger[i].active_text =''
        }
      }
      this.sortDataV2(listDanger);
    },
    async ApprovedItem(index){
      const danger = this.danger[index];
      this.item_approved = {
        id : danger.id,
        name: danger.name,
        status: danger.status,
        active : danger.active,
        is_old : danger.is_old,
        index : index
      }
      var tmp = {
        id : this.selCategory_old.id,
        name : this.selCategory_old.name,
      }
      this.selCategory = tmp.id
      this.radio_btn = 1
      this.selDanger = null
      this.showApprovedDialog = true
      await this.getListDanger()
    },
    async getListDanger(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listDanger = []
      var filters = {active:true,status : "APPROVED"}
      filters.category_id = this.selCategory
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.category_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/danger/options", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
            var data = response.data.data;
            listDanger = data.list;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
        this.selDanger = null
        this.listDanger = listDanger
      }

    },
    async getListCategory(){
      // console.log("?????")
      var company_id = this.company?.id ?? null;
      console.log("?????",company_id)
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listCategory = []
      // var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/category/options", {limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
            var data = response.data.data;
            listCategory = data.list;
            // total = data.count;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
        console.log("listCategory",listCategory)
        this.listCategory = listCategory
      }
    },
    async EditData(){
    console.log("asdsadsadasd");
      if (await this.validateDataEdit()) {
        return;
      }
      if(this.item_edit.index >= 0){
        var active_text = ''
        var status_text = ''
        if(this.item_edit.status == 'APPROVED'){
          status_text = 'Đã duyệt'
          if(this.item_edit.active == true){
            active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          status_text = 'Chưa duyệt'
          active_text =''
        }
        this.danger[this.item_edit.index] = {
          "id" : this.item_edit.id,
          "name" : this.item_edit.name,
          "active" : this.item_edit.active,
          "status" : this.item_edit.status,
          "is_old" : this.item_edit.is_old,
          "ordinal" : this.item_edit.ordinal,
          "active_text" : active_text,
          "status_text" : status_text,
        }
        var tmp = this.danger
        this.sortDataV2(tmp);
        this.showEditDialog = false
      }
      
    },
    async AddDanger(){
      //check validate
      if (await this.validateDataAdd()) {
        return;
      }
      var tmp = this.danger
      var status_text = "Đã duyệt"
      var active_text = ``
      if(this.active_danger == true){
        active_text = `<i class="pi pi-check success bold"></i>`
      }else{
        active_text = `<i class="pi pi-times danger bold"></i>`
      }
      var count = this.danger.length
      tmp.push({
        is_old : false,
        id: null,
        name: this.name_danger,
        status: 'APPROVED',
        active: this.active_danger,
        status_text : status_text,
        active_text : active_text,
        ordinal : count
      })
      this.name_danger= ""
      this.active_danger = true
      this.sortDataV2(tmp)
    },
    sortDataV2(data){
      var status_w = []
      var status_a = []
      for (let i = 0; i < data.length; i++) {
        if(data[i].status == 'WATTING'){
          status_w.push(data[i])
        }else{
          status_a.push(data[i])
        }
      }
      status_w = this.sortData(status_w,'ordinal','desc')
      // status_a = this.sortData(status_a,'ordinal','desc')
      var tm = [...status_w,...status_a]
      this.danger = tm
    },
    sortData(arr,key,sort='desc'){
      if(sort == 'desc'){
        return arr.slice().sort(function(a, b) {
          return b[key] - a[key];
        });
      }else{
        return arr.slice().sort(function(a, b) {
          return a[key] - b[key];
        });
      }
    },
    async validateDataAdd() {
      let name_danger = document.getElementById("name_danger");
      if (this.name_danger == undefined || this.name_danger == null || this.name_danger == "") {
        name_danger.setCustomValidity("Tên rủi ro không được để trống!");
      } else if (this.name_danger.length > 255) {
        name_danger.setCustomValidity("Tên rủi ro không được quá 255 ký tự!");
      } else {
        var checkExistName = this.danger.filter(f => f.name.toLowerCase().trim() == this.name_danger.toLowerCase().trim());
        if (checkExistName.length > 0){
          name_danger.setCustomValidity(`Tên rủi ro ${this.name_danger} đã tồn tại!`);
        } else {
          name_danger.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validateDataEdit() {
      let name_danger = document.getElementById("name_danger");
      name_danger.setCustomValidity("");

      let name_danger_edit = document.getElementById("name_danger_edit");
      if (this.item_edit.name == undefined || this.item_edit.name == null || this.item_edit.name == "") {
        name_danger_edit.setCustomValidity("Tên rủi ro không được để trống!");
      } else if (this.item_edit.name.length > 255) {
        name_danger_edit.setCustomValidity("Tên rủi ro không được quá 255 ký tự!");
      } else {
        var checkExistName = this.danger.filter((f, i)=> f.name.toLowerCase().trim() == this.item_edit.name.toLowerCase().trim() && i != this.item_edit.index);
        if (checkExistName.length > 0){
          name_danger_edit.setCustomValidity(`Tên rủi ro ${this.item_edit.name} đã tồn tại!`);
        } else {
          name_danger_edit.setCustomValidity("");
        }
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    showDeleteData(index){
      this.showDelete = true
      this.index_deleted = index
    },
    deleteItem() {
      var index = this.index_deleted
      this.showDelete = false
      var danger = this.danger[index];
      if(danger.id){
        this.danger_deleted.push(danger.id)
      }
      this.danger.splice(index, 1)
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let name = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name.setCustomValidity("Tên danh mục không được để trống!");
      } else if (this.name.length > 255) {
        name.setCustomValidity("Tên danh mục không được quá 255 ký tự!");
      } else {
        name.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.danger.length == 0){
        alert("Vui lòng thêm ít nhất một mối nguy");
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        company: this.company,
        name: this.name,
        danger: this.danger,
        active: this.active
      };
      // console.log("saveData", params);
      this.$emit("save", params);

    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.button-box {
  /* min-height: 45px !important; */
  width: 30px !important;
  height: 30px;
  margin: 2px;
}
.button-box-1 {
  /* min-height: 45px !important; */
  /* width: 30px !important;
  height: 30px; */
  margin-left : 6px;
}
.number-box {
  display: block;
  // min-height: 48px !important;
  width: 46% !important;
}
.text-box-dialog {
  display: block;
  // min-height: 48px !important;
  min-width: 400px;
}
.number-text-box {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  /* padding-left: 10px !important; */
}
/**css table */
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}

/**end css table */
</style>
